import VCarousel from 'vuetify/lib/components/VCarousel/VCarousel';
import VBtn from 'vuetify/lib/components/VBtn/VBtn';
import VIcon from 'vuetify/lib/components/VIcon/VIcon';
import ButtonGroup from 'vuetify/lib/mixins/button-group';

export default VCarousel.extend({
    name: 'PrimeCarousel',
    props: {
        loop: Boolean,
    },
    methods: {
        next() {
            this.isReverse = false;
            let nextIndex = (this.internalIndex + 1) % this.items.length;
            if (this.loop || nextIndex !== 0) {
                const item = this.items[nextIndex];
                this.internalValue = this.getValue(item, nextIndex);
            }
        },
        prev() {
            this.isReverse = true;
            const lastIndex = (this.internalIndex + this.items.length - 1) % this.items.length;
            if (this.loop || lastIndex < this.internalValue) {
                const item = this.items[lastIndex];
                this.internalValue = this.getValue(item, lastIndex);
            }
        },
        recalclutateAutoHeight() {
            this.$nextTick(() => {
                this.internalHeight = undefined;
                this.$nextTick(() => {
                    this.internalHeight = 'auto';
                });
            });
        },
        genItems: function genItems() {
            var _this2 = this;

            var length = this.items.length;
            var children = [];
            for (var i = 0; i < length; i++) {
                var child = this.$createElement(VBtn, {
                    class: {
                        'v-carousel__controls__item': true
                    },
                    props: {
                        icon: true,
                        small: true,
                        value: this.getValue(this.items[i], i)
                    }
                }, [this.$createElement(VIcon, {
                    props: { size: 18 }
                }, this.delimiterIcon)]);
                children.push(child);
            }
            return this.$createElement(ButtonGroup, {
                props: {
                    value: this.internalValue,
                    mandatory: true,
                },
                on: {
                    change: function change(val) {
                        if (val !== undefined) {
                            _this2.internalValue = val;
                        }
                    }
                },
            }, children);
        },
    },
    watch: {
        internalValue() {
            if (this.height === 'auto') {
                this.recalclutateAutoHeight();
            }
        },
    }
});
